export default "__VITE_ASSET__C83TOiHz__"